import { PremiumsPaymentSchedule } from '@app/domain/model/eshop/transport/PremiumsPaymentSchedule';
import { TransportPremiumsResponse } from '@app/domain/model/eshop/transport/TransportPremiumsResponse';

export function buildMergedPaymentSchedule(
    selectedMtplPremium: Nullable<TransportPremiumsResponse>,
    selectedCascoPremium: Nullable<TransportPremiumsResponse>,
    ridersSum: number,
): PremiumsPaymentSchedule[] {
    const selectedPremiums: TransportPremiumsResponse[] = [];

    if (selectedMtplPremium) {
        selectedPremiums.push(selectedMtplPremium);
    }

    if (selectedCascoPremium) {
        selectedPremiums.push(selectedCascoPremium);
    }

    if (selectedPremiums.length === 0) return [];

    const allSchedules: PremiumsPaymentSchedule[] = [];
    selectedPremiums.forEach(premium => {
        if (premium.paymentSchedule && premium.paymentSchedule.length > 0) {
            allSchedules.push(...premium.paymentSchedule);
        }
    });

    if (allSchedules.length === 0) return [];

    const scheduleMap = new Map<string, { amount: number; amountAfterDiscount: number }>();
    allSchedules.forEach(schedule => {
        const current = scheduleMap.get(schedule.date) ?? { amount: 0, amountAfterDiscount: 0 };
        scheduleMap.set(schedule.date, {
            amount: current.amount + schedule.amount,
            amountAfterDiscount: current.amountAfterDiscount + schedule.amountAfterDiscount,
        });
    });

    const mergedSchedule = Array.from(scheduleMap.entries())
        .map(([date, { amount, amountAfterDiscount }]) => ({ date, amount, amountAfterDiscount }))
        .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

    if (mergedSchedule.length > 0 && ridersSum > 0) {
        mergedSchedule[0] = {
            ...mergedSchedule[0],
            amount: mergedSchedule[0].amount + ridersSum,
            amountAfterDiscount: mergedSchedule[0].amountAfterDiscount + ridersSum,
        };
    }

    return mergedSchedule;
}
